module.exports = __webpack_public_path__ + "static/media/nethermind-bg.b5ed7e15.png";